import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Mail, Send, Linkedin, Twitter } from 'lucide-react';

export default function ContactSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation<HTMLElement>({ threshold: 0.2 });

  return (
    <section
      id="contact"
      ref={sectionRef}
      className="relative bg-[#05060B] grid-bg py-20 lg:py-24 overflow-hidden"
    >
      <div className="relative z-10 w-full px-6 lg:px-12 xl:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
            <div 
              className={`transition-all duration-1000 ${
                isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
              }`}
            >
              <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-xs font-medium uppercase tracking-wider mb-6">
                Get in Touch
              </span>
              <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
                Let's talk{' '}
                <span className="text-cyan-400 cyan-glow">growth.</span>
              </h2>
              <p className="text-lg text-dark-400 mb-8">
                Whether you're ready to start or just exploring options, we'd love to hear from you. No pressure, just a conversation.
              </p>

              <div className="space-y-6 mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-cyan-500/10 flex items-center justify-center">
                    <Mail className="w-5 h-5 text-cyan-400" />
                  </div>
                  <div>
                    <div className="text-sm text-dark-500">Email</div>
                    <a href="mailto:hello@darkforcedigital.com" className="text-white hover:text-cyan-400 transition-colors">
                      hello@darkforcedigital.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <a href="#" className="w-12 h-12 rounded-xl bg-dark-900 flex items-center justify-center text-dark-400 hover:text-cyan-400 hover:bg-dark-800 transition-all">
                  <Linkedin className="w-5 h-5" />
                </a>
                <a href="#" className="w-12 h-12 rounded-xl bg-dark-900 flex items-center justify-center text-dark-400 hover:text-cyan-400 hover:bg-dark-800 transition-all">
                  <Twitter className="w-5 h-5" />
                </a>
              </div>
            </div>

            <div 
              className={`transition-all duration-1000 delay-200 ${
                isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
              }`}
            >
              <div className="glass-card p-8">
                <h3 className="font-heading font-semibold text-xl text-white mb-6">
                  Send us a message
                </h3>
                <form className="space-y-4">
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm text-dark-400 mb-2">Name</label>
                      <input 
                        type="text" 
                        className="w-full px-4 py-3 rounded-xl bg-dark-900/50 border border-cyan-500/20 text-white placeholder-dark-500 focus:border-cyan-400 focus:outline-none transition-colors"
                        placeholder="Your name"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-dark-400 mb-2">Email</label>
                      <input 
                        type="email" 
                        className="w-full px-4 py-3 rounded-xl bg-dark-900/50 border border-cyan-500/20 text-white placeholder-dark-500 focus:border-cyan-400 focus:outline-none transition-colors"
                        placeholder="you@company.com"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm text-dark-400 mb-2">Company</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-3 rounded-xl bg-dark-900/50 border border-cyan-500/20 text-white placeholder-dark-500 focus:border-cyan-400 focus:outline-none transition-colors"
                      placeholder="Your company"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-dark-400 mb-2">Message</label>
                    <textarea 
                      rows={4}
                      className="w-full px-4 py-3 rounded-xl bg-dark-900/50 border border-cyan-500/20 text-white placeholder-dark-500 focus:border-cyan-400 focus:outline-none transition-colors resize-none"
                      placeholder="Tell us about your Amazon business and goals..."
                    />
                  </div>
                  <button 
                    type="submit"
                    className="w-full btn-primary inline-flex items-center justify-center gap-2 group"
                  >
                    <Send className="w-4 h-4" />
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
